import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Col, Container, Row } from "reactstrap";
import SvgIcon from "../../Components/CommonComponents/SvgIcon/SvgIcon";
import { PropsTypes } from "../../Types/CommonElementType";
import H3 from "../Headings/H3Element";
import { Fragment } from "react/jsx-runtime";

const Breadcrumbs: React.FC<PropsTypes> = ({ mainTitle, parent }) => {
  return (
    <Fragment>
      <Container fluid>
        <div className="page-title">
          <Row>
            <Col md="6" className="p-0">
              <H3>{mainTitle}</H3>
            </Col>
            <Col md="6" className="p-0">
              <Breadcrumb>
                <BreadcrumbItem>
                  <Link to={`${process.env.PUBLIC_URL}/dashboard/default`}>
                    <SvgIcon className="stroke-icon" iconId="fill-home" />
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>{parent}</BreadcrumbItem>
                <BreadcrumbItem active>{mainTitle}</BreadcrumbItem>
              </Breadcrumb>
            </Col>
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};

export default Breadcrumbs;
